import First from './components/First';
import css from './index.module.scss';
import PageConPc from '@/components/productSmart/blade/detail/indexDynamic';
import Annotation from '@/components/Annotation';

export default function BladePC() {
    return (
        <div className={`blade-pc ${css.bladePC}`}>
            <First />
            <PageConPc />
            <Annotation borderTopColor="transparent" bgColor="#000" boxStyle={{ width: '1120px' }} product="BLADE" />
        </div>
    );
}
